import axios, { AxiosError, AxiosResponse } from 'axios';
import { httpRequestExternal } from './request';

// const easyAppApiUrl = 'http://localhost:3001';
const easyAppApiUrl =
  'https://ezappapitesting-cze9fvhkepdkf7fj.westus-01.azurewebsites.net';

/**
 *  TODO:
 *  After auth is implemented on credibuilder-api
 *  - send token with requests
 */

export function getUserApplicationsService(
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getUserApplicationsService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/applications`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getApplicationGroupsService(
  token: string,
  object_id: any
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getApplicationGroupsService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups?object_id=${encodeURIComponent(object_id)}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getApplicationsByGroupService(
  application_group: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getApplicationsByGroupService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/${application_group}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function updateApplicationStatusService(
  id: string,
  body: any,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for updateApplicationStatusService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/status/${id}`,
      'patch',
      null, // token
      body,
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function updateAppInfoService(
  body: any,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for updateAppInfoService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/applications/update-app-field`,
      'patch',
      null, // token
      body,
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function updateAppGroupService(
  id: string,
  body: any,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for updateAppGroupService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/field/${id}`,
      'patch',
      null, // token
      body,
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function updateLeaseStatusService(
  data: any,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for updateAppGroupService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/lease`,
      'post',
      null, // token
      data,
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function updateApplicationDataService(
  body: any,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for updateAppGroupService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/applications/update-field`,
      'patch',
      null, // token
      body,
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getAppGroupPlaidResultsService(
  application_group: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getAppGroupPlaidResultsService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/plaid/results?app_group=${application_group}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getApplicationGroupScreeningService(
  application_group: string,
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/screening/results/?app_group=${application_group}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getApplicationGroupScreeningFromTUService(
  appGroupId: string,
  tuPropertyId: string,
  screeningId: string,
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/screening/result/?appGroupId=${appGroupId}&tuPropertyId=${tuPropertyId}&screeningId=${screeningId}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getPropertyUnitRentService(
  id: string,
  unitId: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getPropertyUnitRentService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/properties/${id}/units/${unitId}/rent`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getPropertyUnitsService(
  id: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getPropertyUnitsService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/properties/${id}/units`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getAllPropertyUnitsService(
  id: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getPropertyUnitsService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/properties/${id}/units/all`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getPropertyInfoService(
  id: string,
  // token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    // console.log('Token for getPropertyInfoService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/property/${id}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getUnitDetailsService(
  propertyId: string,
  unitId: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/resman/properties/${propertyId}/units/${unitId}/details`,
      'get',
      null,
      null,
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getTransactionCategoriesService(
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for getTransactionCategoriesService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/resman/transaction-categories`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function requestApplicationGroupScreeningService(
  data: any,
  token: string,
  ApplicationNumber?: any,
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for requestApplicationGroupScreeningService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/screening/request/app-group`,
      'post',
      null, // token
      ApplicationNumber ? { data, ApplicationNumber } : {data}, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function saveLeaseDraftService(
  data: any,
  appGroupID: string,
  token: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    console.log('Token for saveLeaseDraftService:', token);
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/save-draft`,
      'post',
      null, // token
      {data, appGroupID}, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getLeasePreviewService(data: any) {
  return axios.post(`${easyAppApiUrl}/resman/generate-lease-pdf`, data, {
    responseType: "blob",
  });
}

export async function sendLeaseService(
  formData: FormData,
): Promise<AxiosResponse> {
  try {
    const response = await axios.post(`${easyAppApiUrl}/docusign/send-for-signing`, formData);

    return response;
  } catch (err) {
    const error = err as AxiosError;
    throw error;
  }
}

export function getRentalVerificationFormService(body: any): Promise<AxiosResponse> {
  return axios.post(`${easyAppApiUrl}/application-groups/generate-rental-verification`, body, {
    responseType: "blob",
  });
}

export function getSignedLeaseService(envelopeId: string): Promise<AxiosResponse> {
  return axios.get(`${easyAppApiUrl}/docusign/${envelopeId}/pdf`, {
    responseType: "blob",
  });
}

export function getPropertyFeeRecordService(
  id: string,
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/properties/property/${id}`,
      'get',
      null, // token
      null, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

export function getAdverseActionPreviewService(data: any) {
  return axios.post(
    `${easyAppApiUrl}/adverse-action/generate-preview`,
    data,
    { responseType: 'json' }
  );
}

export function sendAdverseActionEmailsService(formData: FormData) {
  return axios.post(
    `${easyAppApiUrl}/adverse-action/send-emails`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'json',
    }
  );
}


export function joinApplicationGroupsService(payload: {
  application_group_id: string;
  applicationGroupIds: string[];
}): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/join`,
      'post',
      null, // token
      payload, // body
      false // has params
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/**
 * Refresh IDV data from Plaid for a specific user
 */
export function refreshIDVForUserService(
  userId: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/plaid/refresh-idv`,
      'post',
      null,
      { userId },
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/**
 * Refresh IDV data from Plaid for all users in an application group
 */
export function refreshIDVForGroupService(
  appGroupId: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/plaid/refresh-idv-group`,
      'post',
      null,
      { appGroupId },
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/* ============================================
 * LEASE VERSIONING SERVICES
 * ============================================ */

/**
 * Get lease history for an application group
 */
export function getLeaseHistoryService(
  applicationGroupId: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/${applicationGroupId}/lease-history`,
      'get',
      null,
      null,
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/**
 * Get current active lease for an application group
 */
export function getCurrentLeaseService(
  applicationGroupId: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/${applicationGroupId}/current-lease`,
      'get',
      null,
      null,
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/**
 * Create a new lease version (supersedes the previous one)
 * Called when user clicks "Create New Lease" after a lease has been sent
 */
export function createNewLeaseVersionService(
  applicationGroupId: string,
  createdByUserId?: string
): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/${applicationGroupId}/new-lease-version`,
      'post',
      null,
      { created_by_user_id: createdByUserId },
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}

/* ============================================
 * SPLIT APPLICATION SERVICES
 * ============================================ */

/**
 * Split an application from a group into its own new group
 * Use case: Co-applicant decides not to proceed or needs separate processing
 * 
 * @param sourceGroupId - The ID of the original application group
 * @param applicationId - The ID of the application to split out
 * @param archive - Whether to archive the split application
 */
export function splitApplicationFromGroupService(payload: {
  sourceGroupId: string;
  applicationId: string;
  archive: boolean;
}): Promise<AxiosResponse | AxiosError> {
  return new Promise((resolve, reject) => {
    httpRequestExternal(
      `${easyAppApiUrl}/application-groups/${payload.sourceGroupId}/split`,
      'post',
      null,
      {
        applicationId: payload.applicationId,
        archive: payload.archive,
      },
      false
    )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((err: AxiosError) => {
        reject(err);
      });
  });
}